module.exports = __webpack_public_path__ + "static/room2_1-f80695fd612e9fd63476f4af732b24b0.jpg";